import script from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCloseButton.vue?vue&type=style&index=0&id=9d94e4c8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d94e4c8"]])

export default __exports__